// This component forces Tailwind to include all necessary classes
export default function TailwindTest() {
  return (
    <div className="hidden">
      {/* Force include all classes used in the app */}
      <div className="bg-gray-900 text-white min-h-screen">
        <div className="hologram-card btn-primary btn-secondary cyber-text neon-glow">
          <div className="max-w-4xl mx-auto px-4 py-8 text-center mb-8 space-x-3 mb-4">
            <div className="w-12 h-12 text-cyan-400 text-4xl font-bold text-gray-400 text-lg">
              <div className="p-8 mb-6 w-20 h-20 mx-auto mb-6 text-2xl mb-4 mb-8">
                <div className="inline-flex items-center space-x-3 font-semibold py-4 px-8 rounded-lg">
                  <div className="cursor-pointer transition-all duration-300 transform hover:scale-105">
                    <div className="w-6 h-6 hidden space-y-6 max-w-md max-h-80 border-2 border-gray-700">
                      <div className="w-8 h-8 mb-4 animate-spin text-sm mt-2">
                        <div className="bg-gray-800/50 border border-gray-700 p-6 text-xl mb-4">
                          <div className="bg-gradient-to-r from-cyan-500/10 to-purple-600/10 p-4 border-cyan-500/30">
                            <div className="flex justify-between text-3xl text-right text-gray-300">
                              <div className="bg-gray-700 hover:bg-gray-600 py-2 px-6 transition-colors">
                                <div className="animate-pulse bg-gradient-to-r from-cyan-500 to-purple-600">
                                  <div className="hover:from-cyan-400 hover:to-purple-500 matrix-bg cyber-grid">
                                    <div className="animate-float animate-pulse-glow gradient-bg">
                                      Test
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
